import { Card, CardContent, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { setTask } from '../../store/actions/taskActions';
import Sonlandir from './FinalProcess';
import Scheduling from './Scheduling';

const useStyles = makeStyles(() => ({
  root: {},
  content: {
    minHeight: 430
  },
  submitButtonFile: {
    width: '100%'
  }
}));

function WorkOrderEnd({ className, ReceiptNo, readonly, tasks, setTask }) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');


  return (
    <Card className={clsx(classes.root, className)}>
      <CardContent className={classes.content}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={7} lg={7}>
            <Scheduling ReceiptNo={ReceiptNo} readonly={false}/>
          </Grid>
          <Grid item xs={12} sm={5} lg={5}>
            <Sonlandir ReceiptNo={ReceiptNo} readonly={false}/>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

WorkOrderEnd.propTypes = {
  className: PropTypes.string
};

export default connect(
  state => ({
    tasks: state.tasks1
  }),
  { setTask }
)(WorkOrderEnd);
